<div class="row">
  <div class="col-xs-12 col-md-12">
    <section>
      <h1>Actualización de contraseña</h1>

      <alertbox
        [messageBox]="messageCabecera"
        [typeException]="typeException"
        [messageComplet]="messageComplet"
      ></alertbox>

      <p>Por favor, cambie su contraseña. Si es su primer acceso o han pasado 6 meses desde que estableció la actual es
        necesario actualizarla con el objetivo de ofrecerle mayor seguridad.</p>

      <div class="col-xs-12 box">
        <form
          class=""
          id="form"
          method="get"
          action=""
        >
          <h2 class="line">Cambio de contraseña</h2>
          <fieldset>
            <legend class="sr-only">Formulario datos solicitante</legend>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'nombre'"
                  [setLabel]="'Nombre'"
                  [setValue]="nombre"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="nombre = $event"
                ></sacyr-input>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-3">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'login'"
                  [setLabel]="'Usuario'"
                  [setValue]="login"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="login = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'password'"
                  [setName]="'oldPassword'"
                  [setLabel]="'Contraseña actual'"
                  [setValue]="oldPassword"
                  [setRequired]="true"
                  (outValue)="oldPassword = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'password'"
                  [setName]="'password'"
                  [setLabel]="'Contraseña nueva'"
                  [setValue]="password"
                  [setRequired]="true"
                  [compareWith]="passwordConfirm"
                  (outValue)="password = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'password'"
                  [setName]="'passwordConfirm'"
                  [setLabel]="'Confirmar contraseña'"
                  [setValue]="passwordConfirm"
                  [setRequired]="true"
                  [compareWith]="password"
                  (outValue)="passwordConfirm = $event"
                ></sacyr-input>
              </div>
            </div>

          </fieldset>
        </form>
      </div>
    </section>

    <div class="input-form input-button">
      <button
        (click)="firstAccess()"
        type="submit"
        class="btn-default"
        value=""
      >Enviar</button>
    </div>
  </div>
</div>
